import { render } from "./CommentReplies.vue?vue&type=template&id=4063f072&scoped=true"
import script from "./CommentReplies.vue?vue&type=script&lang=js"
export * from "./CommentReplies.vue?vue&type=script&lang=js"

import "./CommentReplies.vue?vue&type=style&index=0&id=4063f072&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063f072"]])

export default __exports__